import { useEffect, useState } from 'react';
import Login from './Login.tsx';
import ProjectIndex from './ProjectIndex.tsx';

const { VITE_BACKEND_BASE_URL: BACKEND_BASE_URL } = import.meta.env;

type AuthState = 'loading' | 'authed' | 'anon';

export default function Backend() {
  const [auth, setAuth] = useState<AuthState>('loading');

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND_BASE_URL}/api/auth/me`, { credentials: 'include' })
      .then((r) => !cancelled && setAuth(r.ok ? 'authed' : 'anon'))
      .catch(() => !cancelled && setAuth('anon'));
    return () => {
      cancelled = true;
    };
  }, []);

  async function handleLogout() {
    await fetch(`${BACKEND_BASE_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
    setAuth('anon');
  }

  if (auth === 'loading') return <div style={{ padding: 16 }}>Loading…</div>;
  if (auth === 'anon') return <Login onLogin={() => setAuth('authed')} />;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 8 }}>
        <button onClick={handleLogout}>Log out</button>
      </div>
      <ProjectIndex />
    </div>
  );
}
